<template>
  <el-drawer size="100%" title="我的反馈" :visible.sync="show" id="feedBackDrawer">
    <el-card class="wrap-out" shadow="never">
      <div>
        <el-timeline>
          <el-timeline-item v-for="(activity, index) in activities" :key="index" size="normal" placement="top" :timestamp="activity.createTime">
            <el-card class="content" shadow="never">
              <p>反馈意见：{{ activity.info }}</p>
              <!--    <p>状态：{{ statusFormat(activity.status) }}</p>
                            <p>预计解决时间：{{ activity.version }}</p> -->
              <p>处理意见：{{ activity.remark }}</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-card>
  </el-drawer>
</template>
<script>
import axios from 'axios'
export default {
  name: 'devopsDrawer',
  props: {
    empId: String,
  },
  data() {
    return {
      loading: false,
      queryParams: {
        pageNum: 1,
        userName: undefined,
        name: undefined,
      },
      //时间轴参数
      activities: [],
      //drawer是否展示
      show: false,
    }
  },
  created() {
  },
  methods: {
    //查看个人反馈
    getBackInfo() {
      this.loading = true
      this.show = true
      //不能传一个空参数
      axios
        .get(
          process.env.VUE_APP_OA_HOST_URL + 'devops/feedBack/find',
          this.queryParams
        )
        .then((response) => {
          this.activities = response
          this.loading = false
        })
    },
    // 工单状态格式化
    statusFormat(row) {
      return this.selectDictLabels(this.problemStatus, row)
    },
    selectDictLabels(datas, value) {
      var actions = []
      Object.keys(datas).map((key) => {
        if (datas[key].value == '' + value) {
          actions.push(datas[key].text)
          return false
        }
      })
      return actions.join('')
    },
  },
}
</script>
<style scoped>
#feedBackDrawer .wrap-out {
  padding: 12px;
}
#feedBackDrawer .wrap-out .content {
  padding: 12px;
}
</style>



// WEBPACK FOOTER //
// src/feedBackDrawer.vue